import { Controller } from "@hotwired/stimulus"
import { CountUp } from "countup.js/dist/countUp"
import CalHeatmap from 'cal-heatmap'
import Legend from 'cal-heatmap/plugins/Legend'
import Tooltip from 'cal-heatmap/plugins/Tooltip'

export default class extends Controller {
  static targets = ["countup", "calendrier", "sommaire"]
  static values = {
    maxcal: { type: Number, default: 1500 },
    start: { type: Number, default: 0 },
    end: { type: Number, default: 1 },
    duration: { type: Number, default: 1.5 },
    append: { type: String, default: '$' },
    decimals: { type: Number, default: 2}
  }

  calheat = null
  calclickedElements = new Set();

  connect() {
    // Code here runs when the page loads
    this.initializeTableaudebords()
  }

  disconnect(){
    this.calheat = null
    this.calclickedElements = null
  }

  // Functions you want available for direct call
  initializeTableaudebords() {
   
    this.calendrierTargets.forEach(element => {
      this.initialize_calendrier(element)
    })
    if (this.hasSommaireTarget) {
      this.initialize_sommaire()
      //console.log("Sommaire initialized")
    }
    this.countupTargets.forEach(element => {
      this.initialize_countup(element)
    })

  }

  initialize_countup(element){
    const start = element.getAttribute('data-countup-start') || this.startValue
    const end = element.getAttribute('data-countup-end') || this.endValue
    const duration = element.getAttribute('data-countup-duration') || this.durationValue
    const append = element.getAttribute('data-countup-append') || this.appendValue
    const decimals = element.hasAttribute('data-countup-decimals') || this.decimalsValue

    const options = {
      startVal: start,
      decimalPlaces: decimals,
      duration: duration,
      suffix: append
    };

    var countUp = new CountUp(element, end, options);
    countUp.start();    
  }

  initialize_sommaire() {
    // Check if any of these chart containers exist on the page
    const chartElements = document.querySelectorAll("#top12_util_cf, #top12_rev_cf, #profil_revenu, #count_profil_jours");
    
    if (chartElements.length) {
      // Check if we're on a mobile device
      const width = window.innerWidth || document.body.clientWidth;
      if (width < 768) {
        const chart_arr = ["top12_util_cf", "top12_rev_cf", "profil_revenu", "count_profil_jours"];
        
        chart_arr.forEach(function(element) {
          // Make sure the element exists
          if (document.getElementById(element)) {
            // Check if the chart exists in Chartkick.charts
            const chart = Chartkick.charts[element];
            
            // Only proceed if chart is defined
            if (chart && chart.options) {
              chart.options.legend = 'bottom';
              chart.redraw();
            }
          }
        });
      }
    }
  }  
  
  initialize_calendrier(element){
    const maxcal = element.getAttribute('data-calendrier-maxcal') || this.maxcalValue
    var width = window.innerWidth || document.body.clientWidth
    if(width < 768){
      var verticalOrientation = true;
      var cellSize = 45;
    }else if(width < 992){
      var verticalOrientation = true;
      var cellSize = 50;
    }else if(width < 1200){
      var verticalOrientation = false;
      var cellSize = 60;
    }else{
      var verticalOrientation = false;
      var cellSize = 60;
    }

    const currentDate = new Date();
    const options = {
      itemSelector: "#cal-heatmap",
      range: 2,
      verticalOrientation: verticalOrientation,
      data: { source: location.protocol + "//" + window.location.host + "/calendrier_data",
              type: 'json',
              x: (datum) => +new Date(datum['date']),
              y: (datum) => +datum['value']},
      date: {  start: new Date(currentDate.getFullYear(), currentDate.getMonth()-1, 1), // Start of last month
               min: new Date(currentDate.getFullYear() - 1, currentDate.getMonth()-1, 1), // Same month last year
               max: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)}, // Last day of current month
      domain: { type: 'month',
                padding: [20, 20, 20, 20],
                locale: 'fr',
                label: { position: 'top',
                         offset: {y: -20},
                         text: function(date) {
                          const months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
                          // Convert to Date object if it's not already one
                          const dateObj = date instanceof Date ? date : new Date(date);
                          // Subtract 1 from the month index to correct the display
                          const monthIndex = (dateObj.getMonth() + 1 + 12) % 12; // Add 12 and mod 12 to handle negative index
                          return months[monthIndex] + ' ' + dateObj.getFullYear();
                        }
                  }
              },           
      scale: { color: { range: ['#80E1FF', '#E400DE'], domain: [0,maxcal] }},        
      subDomain: {type: "xDay",
                  label: 'DD',
                  radius: 4,
                  width: cellSize,
                  height: cellSize,
                  gutter: 10,
                  id:  function(timestamp) {
                    const date = new Date(timestamp);
                    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
                  }},
    }
    const plugins = [
      [
        Legend,
        {
          label: 'Total journalier ($)',
          itemSelector: '#legend-label',
          width: 500,
        }
      ],[
        Tooltip,
        { text: function (timestamp, value, dayjsDate) {
          if (value != null ){
            return `${value}$ - ${new Date(timestamp).toISOString().slice(0, 10)}`;
          }else{ return null}},
          enabled: true
        }
      ]
    ]

    this.calheat = new CalHeatmap();
    this.calheat.paint(options,plugins)

    this.calheat.on('click', (event, timestamp, value) => {
      if (value !== null) {
        event.preventDefault();
        var date_convertie = new Date(timestamp).toISOString().slice(0, 10);
        const elementId = `${timestamp}_${value}`;
        if (!this.calclickedElements.has(elementId)) {
          this.calclickedElements.add(elementId);
          $.ajax({
            url: '/generateur_pop_over',
            method: "GET",
            data: {date: date_convertie, timestamp: timestamp},
            dataType: "script"
          });
        }
      }
    });
  }

  next_calendrier(event){
    event.preventDefault();
    this.calheat.next();
  }

  previous_calendrier(event){
    event.preventDefault();
    this.calheat.previous();
  }  
}
